<template>
  <div class="methodology-items">
    <div
      v-if="
        action.email.template.refTextLeft && action.email.template.refTextRight
      "
      class="row d-flex d-sm-none"
      style="heigth: 25px; margin: 0"
    >
      <div class="col-6" style="justify-content: left; padding: 0">
        <span
          class="text-ref"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-if="lang === 'br'"
        >
          {{ action.email.template.refTextLeft }}
        </span>
        <span
          class="text-ref"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-else-if="lang === 'us'"
        >
          {{ action.email.template.refTextLeftEn }}
        </span>
        <span
          class="text-ref"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-else-if="lang === 'es'"
        >
          {{ action.email.template.refTextLeftEs }}
        </span>
      </div>
      <div
        class="col-6 text-right"
        style="justify-content: flex-end; padding: 0"
      >
        <span
          class="text-ref"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-if="lang === 'br'"
        >
          {{ action.email.template.refTextRight }}
        </span>
        <span
          class="text-ref"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-else-if="lang === 'us'"
        >
          {{ action.email.template.refTextRightEn }}
        </span>
        <span
          class="text-ref"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-else-if="lang === 'es'"
        >
          {{ action.email.template.refTextRightEs }}
        </span>
      </div>
    </div>
    <div
      v-if="actionMetric === 'nps-0-10' || actionMetric === 'csat-0-10(media)'"
    >
      <template v-if="isLinkQrCode">
        <span
          class="text-ref d-none d-sm-block"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
        >
          <span v-if="lang === 'br'">{{
            action.email.template.refTextLeft
          }}</span>

          <span v-else-if="lang === 'us'">{{
            action.email.template.refTextLeftEn
          }}</span>

          <span v-else-if="lang === 'es'">{{
            action.email.template.refTextLeftEs
          }}</span>
        </span>
        <div
          class="button-item"
          :style="handleButtonStyle(i)"
          :class="`${surveyColor}
      ${i === testNpsReview ? 'selected' : 'unselected'}`"
          v-for="(item, i) in 11"
          :key="i"
          @click="setTestNpsReview(i)"
        >
          {{ i }}
        </div>
        <span
          class="text-ref d-none d-sm-block"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-if="lang === 'br'"
        >
          {{ action.email.template.refTextRight }}
        </span>
        <span
          class="text-ref d-none d-sm-block"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-else-if="lang === 'us'"
        >
          {{ action.email.template.refTextRightEn }}
        </span>
        <span
          class="text-ref d-none d-sm-block"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
          v-else-if="lang === 'es'"
        >
          {{ action.email.template.refTextRightEs }}
        </span>
      </template>
      <template v-else>
        <span
          class="text-ref d-none d-sm-block"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
        >
          <span v-if="lang === 'br'">{{
            action.email.template.refTextLeft
          }}</span>

          <span v-else-if="lang === 'us'">{{
            action.email.template.refTextLeftEn
          }}</span>

          <span v-else-if="lang === 'es'">{{
            action.email.template.refTextLeftEs
          }}</span>
        </span>
        <div
          class="button-item"
          :style="handleButtonStyle(i)"
          :class="`${surveyColor || action.email.template.scale}
      ${i === testNpsReview ? 'selected' : 'unselected'}`"
          v-for="(item, i) in 11"
          :key="i"
          @click="setTestNpsReview(i)"
        >
          {{ i }}
        </div>
        <span
          class="text-ref d-none d-sm-block"
          :style="{
            color:
              action.email.template.scale !== 'colors' &&
              action.email.template.scale !== 'fixedColors'
                ? action.email.template.backgroundtext
                : '#000000',
          }"
        >
          <span v-if="lang === 'br'">{{
            action.email.template.refTextRight
          }}</span>

          <span v-else-if="lang === 'us'">{{
            action.email.template.refTextRightEn
          }}</span>

          <span v-else-if="lang === 'es'">{{
            action.email.template.refTextRightEs
          }}</span>
        </span>
      </template>
    </div>

    <div
      v-else-if="
        actionMetric === 'nps-1-5' ||
        actionMetric === 'ces-1-5' ||
        actionMetric === 'csat-1-5' ||
        actionMetric === 'csat-1-5(media)'
      "
    >
      <span
        class="text-ref d-none d-sm-block"
        :style="{
          color:
            action.email.template.scale !== 'colors' &&
            action.email.template.scale !== 'fixedColors'
              ? action.email.template.backgroundtext
              : '#000000',
        }"
      >
        <span v-if="lang === 'br'">{{
          action.email.template.refTextLeft
        }}</span>

        <span v-else-if="lang === 'us'">{{
          action.email.template.refTextLeftEn
        }}</span>

        <span v-else-if="lang === 'es'">{{
          action.email.template.refTextLeftEs
        }}</span>
      </span>

      <div
        class="button-item"
        :style="handleButtonStyle(item)"
        :class="`${surveyColor || action.email.template.scale}
      ${item === testNpsReview ? 'selected' : 'unselected'} nps-15`"
        v-for="item in 5"
        :key="item"
        @click="setTestNpsReview(item)"
      >
        {{ item }}
      </div>
      <span
        class="text-ref d-none d-sm-block"
        :style="{
          color:
            action.email.template.scale !== 'colors' &&
            action.email.template.scale !== 'fixedColors'
              ? action.email.template.backgroundtext
              : '#000000',
        }"
      >
        <span v-if="lang === 'br'">{{
          action.email.template.refTextRight
        }}</span>

        <span v-else-if="lang === 'us'">{{
          action.email.template.refTextRightEn
        }}</span>

        <span v-else-if="lang === 'es'">{{
          action.email.template.refTextRightEs
        }}</span>
      </span>
    </div>

    <div v-else-if="actionMetric === '5-stars'">

      <span
        class="text-ref d-none d-sm-block"
        :style="{
          color:
            action.email.template.scale !== 'colors' &&
            action.email.template.scale !== 'fixedColors'
              ? action.email.template.backgroundtext
              : '#000000',
        }"
      >
        <span v-if="lang === 'br'">{{
          action.email.template.refTextLeft
        }}</span>

        <span v-else-if="lang === 'us'">{{
          action.email.template.refTextLeftEn
        }}</span>

        <span v-else-if="lang === 'es'">{{
          action.email.template.refTextLeftEs
        }}</span>
      </span>

      <div class="mb-2">
        <div class="row">
          <div class="col-xl-12 text-center mt-auto mb-auto align-center">
            <star-rating
              :show-rating="false"
              v-model="review"
              :star-size="60"
              @rating-selected="setTestNpsReview(review)"
            ></star-rating>
          </div>
        </div>
      </div>

      <span
        class="text-ref d-none d-sm-block"
        :style="{
          color:
            action.email.template.scale !== 'colors' &&
            action.email.template.scale !== 'fixedColors'
              ? action.email.template.backgroundtext
              : '#000000',
        }"
      >
        <span v-if="lang === 'br'">{{
          action.email.template.refTextRight
        }}</span>

        <span v-else-if="lang === 'us'">{{
          action.email.template.refTextRightEn
        }}</span>

        <span v-else-if="lang === 'es'">{{
          action.email.template.refTextRightEs
        }}</span>
      </span>
    </div>

    <div v-else>

      <span
        class="text-ref d-none d-sm-block"
        :style="{
          color:
            action.email.template.scale !== 'colors' &&
            action.email.template.scale !== 'fixedColors'
              ? action.email.template.backgroundtext
              : '#000000',
        }"
      >
        <span v-if="lang === 'br'">{{
          action.email.template.refTextLeft
        }}</span>

        <span v-else-if="lang === 'us'">{{
          action.email.template.refTextLeftEn
        }}</span>

        <span v-else-if="lang === 'es'">{{
          action.email.template.refTextLeftEs
        }}</span>
      </span>

      <label class="icon">
        <input
          type="radio"
          :value="1"
          :checked="review === 1"
          v-model="review"
          @click="setTestNpsReview(1)"
        />

        <svg
          width="50"
          height="50"
          viewBox="0 0 215 194"
          xmlns="http://www.w3.org/2000/svg"
          @click="setTestNpsReview(1)"
        >
          <path
            class="thumbs-up"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28 0C12.536 0 0 12.536 0 28V128C0 143.464 12.536 156 28 156H61.8124C61.8305 156.016 61.8486 156.032 61.8668 156.047L102.763 191.464C105.769 194.068 110.231 194.068 113.237 191.464L154.133 156.047C154.151 156.032 154.17 156.016 154.188 156H187C202.464 156 215 143.464 215 128V28C215 12.536 202.464 0 187 0H28Z"
            :fill="review === 1 ? '#007bff' : '#8F8F8F'"
          />
          <path
            d="M68.7 125H73.55V60.6842H68.7C66.1274 60.6842 63.6602 61.7267 61.8411 63.5823C60.022 65.4379 59 67.9547 59 70.5789V115.105C59 117.73 60.022 120.246 61.8411 122.102C63.6602 123.958 66.1274 125 68.7 125ZM146.3 60.6842H112.35L117.792 44.0215C118.277 42.5344 118.41 40.9509 118.178 39.4014C117.946 37.8519 117.356 36.3808 116.458 35.1093C115.559 33.8377 114.378 32.802 113.01 32.0876C111.642 31.3732 110.128 31.0004 108.591 31H107.5L83.25 57.9038V125H136.6L155.573 82.4724L156 80.4737V70.5789C156 67.9547 154.978 65.4379 153.159 63.5823C151.34 61.7267 148.873 60.6842 146.3 60.6842V60.6842Z"
            fill="white"
          />
        </svg>
      </label>
      <label class="icon">
        <input
          type="radio"
          :value="0"
          :checked="review === 0"
          v-model="review"
          @click="setTestNpsReview(0)"
        />

        <svg
          width="50"
          height="50"
          viewBox="0 0 215 194"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="setTestNpsReview(0)"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="thumbs-down"
            d="M28 0C12.536 0 0 12.536 0 28V128C0 143.464 12.536 156 28 156H61.8124C61.8305 156.016 61.8486 156.032 61.8668 156.047L102.763 191.464C105.769 194.068 110.231 194.068 113.237 191.464L154.133 156.047C154.151 156.032 154.17 156.016 154.188 156H187C202.464 156 215 143.464 215 128V28C215 12.536 202.464 0 187 0H28Z"
            :fill="review === 0 ? 'red' : '#8F8F8F'"
          />
          <path
            d="M68.7 31H73.55V95.3158H68.7C66.1274 95.3158 63.6602 94.2733 61.8411 92.4177C60.022 90.5621 59 88.0453 59 85.4211V40.8947C59 38.2705 60.022 35.7537 61.8411 33.8981C63.6602 32.0425 66.1274 31 68.7 31ZM146.3 95.3158H112.35L117.792 111.979C118.277 113.466 118.41 115.049 118.178 116.599C117.946 118.148 117.356 119.619 116.458 120.891C115.559 122.162 114.378 123.198 113.01 123.912C111.642 124.627 110.128 125 108.591 125H107.5L83.25 98.0962V31H136.6L155.573 73.5276L156 75.5263V85.4211C156 88.0453 154.978 90.5621 153.159 92.4177C151.34 94.2733 148.873 95.3158 146.3 95.3158V95.3158Z"
            fill="white"
          />
        </svg>
      </label>

      <span
        class="text-ref d-none d-sm-block"
        :style="{
          color:
            action.email.template.scale !== 'colors' &&
            action.email.template.scale !== 'fixedColors'
              ? action.email.template.backgroundtext
              : '#000000',
        }"
      >
        <span v-if="lang === 'br'">{{
          action.email.template.refTextRight
        }}</span>

        <span v-else-if="lang === 'us'">{{
          action.email.template.refTextRightEn
        }}</span>

        <span v-else-if="lang === 'es'">{{
          action.email.template.refTextRightEs
        }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import starRating from 'vue-star-rating';
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import like from '../../../../assets/like-gray.svg';
import api from '../../../../services/api';

export default {
  name: 'Methodology',
  components: {
    starRating,
    like,
  },

  props: {
    backgroundtext: { type: String, require: false },
    surveySelectedColor: { type: String, required: false },
    surveyBorderColor: { type: String, required: false },
    surveyTextColor: { type: String, required: false },
    surveyColor: { type: String, required: false },
    actionMetric: { type: String },
    isLinkQrCode: { type: Boolean, required: false },
    lang: { type: String, required: false, default: 'br' },
  },
  data: () => ({
    // metric: null,
    researchInfo: null,
    review: null,
    unSelect: false,
  }),
  computed: {
    ...mapState('actions', ['testNpsReview']),
    ...mapFields('actions', ['action']),
  },
  // watch: {
  //   'action.type': function watchMyMethodology() {
  //     this.renderButtons();
  //   },
  // },
  methods: {
    ...mapActions('actions', ['setTestNpsReview']),
    handleButtonStyle(i) {

      if(this.action.email.template.scale !== 'colors' && this.action.email.template.scale !== 'fixedColors')
      return {
            boxShadow:
              i === this.testNpsReview
                ? `0px 10px 30px -7px ${
                    this.action.email.template.templatebuttonselected
                  }`
                : '',
            backgroundColor:
              i === this.testNpsReview
                ? 
                  this.action.email.template.templatebuttonselected
                : this.action.email.template.scale == 'custom' ? '#ffffff' : this.action.email.template.scale,
                
            borderColor: this.getComponentColor(
              this.surveyBorderColor || this.action.email.template.scale,
              this.surveyBorderColor || this.action.email.template.border,
            ),
            color:
              i === this.testNpsReview
                ? this.action.email.template.templatebuttonselectedtext ? 
                  this.action.email.template.templatebuttonselectedtext : 
                 '#ffffff'
                : this.getComponentColor(
                    this.surveyTextColor || this.action.email.template.scale,
                    this.surveyTextColor || this.action.email.template.grade,
                  ),
          }

    },
    getComponentColor(scale, color) {
      if (scale !== 'colors') {
        // if scale is fixedColors the attributes below are not saved in the database, so they are passed to null
        if (scale === 'fixedColors') {
          this.action.email.template.border = null;
          this.action.email.template.grade = null;
          this.action.email.template.button = null;
          this.action.email.template.background = null;
          this.action.email.template.backgroundText = null;
          this.action.email.template.templatebuttonselected = null;
        }
        return color;
      }
      return null;
    },
    // async renderButtons() {
    //   const data = await JSON.parse(localStorage.getItem('_indecx_action'));
    //   this.metric = !data ? this.actionMetric : data.type;
    // },
  },
  async created() {
    if (this.isLinkQrCode) {
      const params = this.$route.query;
      const id = params.id;
      if (this.$route.name === 'QRCode Research Page' || 'Link Research Page') {
        const response = await api.get(
          `/qrcode-research-info/${this.$route.params.actionId}`,
          {
            params: { id },
          },
        );
        this.researchInfo = response.data.action;
        this.$store.state.actions.action = this.researchInfo;
      }
    }

    this.review = this.testNpsReview;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.icon {
  padding: 10px;
  font-size: 40px;
  color: $gray;

  &:hover {
    cursor: pointer;
  }
}

.thumbs-up {
  margin-left: 15px;

  &:hover {
    fill: #007bff;
  }
}

.thumbs-down {
  &:hover {
    fill: red;
  }
}

input[type='radio'] {
  display: none;
  &:checked {
    ~ .thumbs-down {
      fill: red;
    }
    ~ .thumbs-up {
      fill: #007bff;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .metrics-reviews {
    text-align: center;
  }
}

.metrics-reviews .vue-star-rating {
  display: block !important;
  padding: 7px;
}

.methodology-items div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  max-width: 100%;
  .button-item {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    width: 50px;
    height: 50px;
    margin: 0 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border-style: solid;
    border-width: 2px;
    background-color: $gray-lighter;
    opacity: 0.6;
    cursor: pointer;
    transition: all 0.2s linear;
    &:hover {
      opacity: 1;
      width: 60px;
      height: 60px;
      font-size: 22px;
      font-weight: bold;
    }
  }
  .button-item.selected {
    -webkit-box-shadow: 0px 10px 30px -7px #606060;
    box-shadow: 0px 10px 30px -7px #606060;
  }
  .fixedColors {
    &:nth-of-type(1),
    &:nth-of-type(2),
    &:nth-of-type(3),
    &:nth-of-type(4),
    &:nth-of-type(5),
    &:nth-of-type(6),
    &:nth-of-type(7) {
      background-color: #d62027;
      color: $white !important;
    }
    &:nth-of-type(1).selected,
    &:nth-of-type(2).selected,
    &:nth-of-type(3).selected,
    &:nth-of-type(4).selected,
    &:nth-of-type(5).selected,
    &:nth-of-type(6).selected,
    &:nth-of-type(7).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px #d62027;
    }
    &:nth-of-type(8),
    &:nth-of-type(9) {
      background-color: #ecdb12;
      color: $white !important;
    }
    &:nth-of-type(8).selected,
    &:nth-of-type(9).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px #ecdb12;
    }
    &:nth-of-type(10),
    &:nth-of-type(11) {
      background-color: #4ce595;
      color: $white !important;
    }
    &:nth-of-type(10).selected,
    &:nth-of-type(11).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px #4ce595;
    }
  }
  .colors {
    &:nth-of-type(1) {
      background-color: $grade-zero;
      color: $white;
    }
    &:nth-of-type(1).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px $grade-zero;
    }
    &:nth-of-type(2) {
      background-color: $grade-one;
      color: $white;
    }
    &:nth-of-type(2).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-one;
      box-shadow: 0px 10px 30px -7px $grade-one;
    }
    &:nth-of-type(3) {
      background-color: $grade-two;
      color: $white;
    }
    &:nth-of-type(3).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-two;
      box-shadow: 0px 10px 30px -7px $grade-two;
    }
    &:nth-of-type(4) {
      background-color: $grade-three;
      color: $white;
    }
    &:nth-of-type(4).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-three;
      box-shadow: 0px 10px 30px -7px $grade-three;
    }
    &:nth-of-type(5) {
      background-color: $grade-four;
      color: $white;
    }
    &:nth-of-type(5).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-four;
      box-shadow: 0px 10px 30px -7px $grade-four;
    }
    &:nth-of-type(6) {
      background-color: $grade-five;
      color: $white;
    }
    &:nth-of-type(6).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-five;
      box-shadow: 0px 10px 30px -7px $grade-five;
    }
    &:nth-of-type(7) {
      background-color: $grade-six;
      color: $white;
    }
    &:nth-of-type(7).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-six;
      box-shadow: 0px 10px 30px -7px $grade-six;
    }
    &:nth-of-type(8) {
      background-color: $grade-seven;
      color: $white;
    }
    &:nth-of-type(8).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-seven;
      box-shadow: 0px 10px 30px -7px $grade-seven;
    }
    &:nth-of-type(9) {
      background-color: $grade-eight;
      color: $white;
    }
    &:nth-of-type(9).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-eight;
      box-shadow: 0px 10px 30px -7px $grade-eight;
    }
    &:nth-of-type(10) {
      background-color: $grade-nine;
      color: $white;
    }
    &:nth-of-type(10).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-nine;
      box-shadow: 0px 10px 30px -7px $grade-nine;
    }
    &:nth-of-type(11) {
      background-color: $grade-ten;
      color: $white;
    }
    &:nth-of-type(11).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-ten;
      box-shadow: 0px 10px 30px -7px $grade-ten;
    }
  }
  .colors.nps-15 {
    &:nth-of-type(1) {
      background-color: $grade-zero;
      color: $white;
    }
    &:nth-of-type(1).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px $grade-zero;
    }
    &:nth-of-type(2) {
      background-color: $grade-four;
      color: $white;
    }
    &:nth-of-type(2).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-four;
      box-shadow: 0px 10px 30px -7px $grade-four;
    }
    &:nth-of-type(3) {
      background-color: $grade-seven;
      color: $white;
    }
    &:nth-of-type(3).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-seven;
      box-shadow: 0px 10px 30px -7px $grade-seven;
    }
    &:nth-of-type(4) {
      background-color: $grade-eight;
      color: $white;
    }
    &:nth-of-type(4).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-eight;
      box-shadow: 0px 10px 30px -7px $grade-eight;
    }
    &:nth-of-type(5) {
      background-color: $grade-ten;
      color: $white;
    }
    &:nth-of-type(5).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-ten;
      box-shadow: 0px 10px 30px -7px $grade-ten;
    }
  }
  .fixedColors.nps-15 {
    &:nth-of-type(1),
    &:nth-of-type(2),
    &:nth-of-type(3) {
      background-color: #d62027;
      color: $white !important;
    }
    &:nth-of-type(1).selected,
    &:nth-of-type(2).selected,
    &:nth-of-type(3).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px #d62027;
    }
    &:nth-of-type(4) {
      background-color: #ecdb12;
      color: $white !important;
    }
    &:nth-of-type(4).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px #ecdb12;
    }
    &:nth-of-type(5) {
      background-color: #4ce595;
      color: $white !important;
    }
    &:nth-of-type(5).selected {
      -webkit-box-shadow: 0px 10px 30px -7px $grade-zero;
      box-shadow: 0px 10px 30px -7px #4ce595;
    }
  }
  .gray-scale {
    background-color: $gray-scale;
    color: $white;
  }
  .no-colors {
    border: 2px solid $gray-scale;
    background-color: $white;
    color: $gray-scale;
    font-weight: bold;
  }
  .selected {
    opacity: 1;
    width: 60px;
    height: 60px;
    font-size: 22px;
    font-weight: bold;
  }
  .unselected {
    opacity: 0.6;
    width: 50px;
    height: 50px;
    font-size: 16px;
    font-weight: bold;
  }
  .text-ref {
    font-size: 14px;
    margin: 5px;
    color: #606060;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
  .row.text-ref {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/methodology/index.vue